import { StripeErrorType } from '@stripe/stripe-js'
import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'
import { makeGuardFromSchema } from 'shared/api/requests/utils'

const TrialUnavailableErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('trial_unavailable'),
})

const ForbiddenAccountLegalEntityErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('forbidden_account_legal_entity'),
})

const TaxNumberInvalidFormatErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('tax_number_invalid_format'),
})

const TaxNumberErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('tax_number'),
})

const CustomerCreationFailedErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('customer_creation_failed'),
})

const StripeErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('stripe_error'),
})

const OMIEClientCreationFailedErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('omie_client_creation_failed'),
})

const BusinessErrorUnionSchema = z.union([
  TrialUnavailableErrorSchema,
  ForbiddenAccountLegalEntityErrorSchema,
  TaxNumberInvalidFormatErrorSchema,
  TaxNumberErrorSchema,
  CustomerCreationFailedErrorSchema,
  StripeErrorSchema,
  OMIEClientCreationFailedErrorSchema,
])

const StripeSDKErrorType: [StripeErrorType, ...StripeErrorType[]] = [
  'api_connection_error',
  'api_error',
  'authentication_error',
  'card_error',
  'idempotency_error',
  'invalid_request_error',
  'rate_limit_error',
  'validation_error',
]

const StripeSDKErrorSchema = z.object({
  type: z.enum(StripeSDKErrorType),
})

const isTrialUnavailableError = makeGuardFromSchema(TrialUnavailableErrorSchema)

const isTaxNumberInvalidFormatError = makeGuardFromSchema(TaxNumberInvalidFormatErrorSchema)

const isForbiddenAccountLegalEntityError = makeGuardFromSchema(
  ForbiddenAccountLegalEntityErrorSchema,
)

const isTaxNumberError = makeGuardFromSchema(TaxNumberErrorSchema)

const isCustomerCreationFailedError = makeGuardFromSchema(CustomerCreationFailedErrorSchema)

const isStripeError = makeGuardFromSchema(StripeErrorSchema)

const isOMIEClientCreationFailedError = makeGuardFromSchema(OMIEClientCreationFailedErrorSchema)

const isStripeSDKError = makeGuardFromSchema(StripeSDKErrorSchema)

const isBusinessError = makeGuardFromSchema(BusinessErrorUnionSchema)

export const BillingFlexApiGuards = {
  isTrialUnavailableError,
  isTaxNumberInvalidFormatError,
  isForbiddenAccountLegalEntityError,
  isTaxNumberError,
  isCustomerCreationFailedError,
  isStripeError,
  isOMIEClientCreationFailedError,
  isStripeSDKError,
  isBusinessError,
}
